import { IUiIcon } from '../../../types/ui'

export const IconView = (
	{
		size = 24,
		imgSize= 24,
		fill = "none",
		stroke = "currentColor"
	}: IUiIcon
) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg"
		     width={`${size}px`}
		     height={`${size}px`}
		     viewBox={`0 0 ${imgSize} ${imgSize}`}
		     fill={fill}
		     stroke={stroke}
		     strokeWidth="2"
		     strokeLinecap="round"
		     strokeLinejoin="round"
		     className="feather feather-eye"
		>
			<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
			<circle cx="12" cy="12" r="3"></circle>
		</svg>
	)
}